.root {
  flex: 1;
  overflow: hidden;
}

.tabListBorder {
  border-bottom: 1px solid;
  border-color: var(--tuna-palette-divider);
}

.tabListRow {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.tabPanel {
  display: flex;
  flex: 1;
  overflow: hidden;
}
